export const DEFAULTS = {
  animation: 'show-modal',
  closer: 'data-comp-modal-closer',
  modal: 'data-comp-modal-element',
  mounted: 'data-comp-modal-mounted',
  state: 'data-comp-modal-state',
  trigger: 'data-comp-modal-trigger',
};

export const STATES = {
  opening: 'opening',
  opened: 'opened',
  closing: 'closing',
  closed: 'closed',
};
